export default {
  title: 'Jouw beoordeling helpt enorm ❤️',
  description: '{{name}} in de {{store}} — tik gewoon op een ster',
  buttons: {
    not_now: 'Niet nu',
    continue: 'Doorgaan',
  },
};
